export default () => window._Motion.opts


/** WEBPACK FOOTER **
 ** ./client/lib/opts.js
 **/